module.exports = "/img/poster_97.png?0bbb48c58ad633e43a828a6605c1ce63";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/poster_97.png
// module id = zQ4O
// module chunks = 57